import { Controller } from "@hotwired/stimulus"

import TomSelect from "tom-select"
import { Spinner } from "spin.js"
import { opts } from "../src/spinner_opts"

export default class extends Controller {
  static targets = ["country", "select"]

  connect() {
    if (document.documentElement.hasAttribute("data-turbo-preview")) return
    this.select = new TomSelect(this.selectTarget, {
      sortField: "text",
      maxItems: 1,
      plugins: ["remove_button"],
      render: {
        option: (item, escape) => `<div class="py-3 flex items-center">
          <div class="flex flex-wrap py-0.5">
            <div class="text-blue-gray-700">${escape(item.text)}</div>
          </div>
        </div>`
      }
    })
    this.select.on("item_add", () => this.clearCountries())
  }

  disconnect() {
    this.teardown()
  }

  teardown() {
    this.select?.destroy()
    this.select = null
    this.stopLoading()
  }

  change(event) {
    if (event.target !== this.selectTarget && !event.target.matches("input.filter-input[type=checkbox]")) return

    if (this.countryTargets.includes(event.target)) {
      this.clearCountries(event.target)
      this.select.clear(true)
    } else if (event.target === this.selectTarget) {
      this.clearCountries()
    }
    this.stopLoading()
    this.table = document.getElementById("brands-table")
    if (this.table) {
      this.spinner = new Spinner(opts).spin(this.table)
      this.table.classList.add("opacity-50")
    }
    this.element.requestSubmit()
  }

  clearCountries(selected) {
    this.countryTargets.forEach(input => { if (input !== selected) input.checked = false })
  }

  stopLoading() {
    this.spinner?.stop()
    this.spinner = null
    this.table?.classList.remove("opacity-50")
    this.table = null
  }
}
